import React from 'react';

import {AppButton} from '../../../../components/Button';
import ConnectionTrackButton from '../../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import analyticsService from '../../../../services/analyticsService';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import tncService from '../../../../services/tncService';
import uamService from '../../../../services/uam/uamService';
import {hideLoader, showLoader} from '../../../../state/ducks/global';
import {dispatch} from '../../../../state/store';
import elementsTesIds from '../../../../test/consts/elementsTesIds';

const SaveContinueButton = (props) => {
    const {legals, ariaLabel, onApproved, legalsSettingsNotNull, acceptedSettingList, deviceType} = props;
    const localizedStrings = getLocalizedStrings();

    const onSaveButtonClick = async () => {
        analyticsService.pushPreferenceCenterContinueEvent(deviceType);
        dispatch(showLoader());

        await tncService.setPreferenceCenterSettings(legals, legalsSettingsNotNull, acceptedSettingList, onApproved);
        await uamService.checkDataCollectionFlow();

        dispatch(hideLoader());
    };

    return (
        <ConnectionTrackButton
            className='mt-6 md:mt-16'
            button={AppButton}
            light
            primary
            ariaLabel={ariaLabel}
            onClick={onSaveButtonClick}
            testId={elementsTesIds.PREF_CENTER_BTN_SAVE}
        >
            {localizedStrings[localizationKeys.PREFERENCE_CENTER_SAVE_AND_CONTINUE_BUTTON_TEXT]}
        </ConnectionTrackButton>
    );
};

export default SaveContinueButton;
